/** @module csi */
define([
	"dojo/_base/config",
	"dojo/_base/lang",
	"dojo/_base/window",
	"dojo/dom",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/parser",
	"dojo/request/xhr",
	"dojo/topic",
	"underscore",
	"csi/_base/array",
	"csi/_base/object",

	// force loading below module to register tracking with Deferred
	"csi/_base/DeferredTracking",
], function (config, lang, win, dom, domClass, domConstruct, parser, xhr, topic, _, csiArray, csiObject) {

	const { require } = window;

	const RootFolderURL = "/WebAccess/";
	const ServerWebAppURL = "/csi-requesthandler";
	const RootRequestURL = ServerWebAppURL + "/plm?";
	const GeneratedFolder = "Generated/";
	const SiteFolder = "Site/";
	const ImageFolder = "Images/";

	const windowLocation = decodeURIComponent(win.doc ? win.doc.location.href : "");
	const serverUrl = windowLocation.substr(0, windowLocation.indexOf(RootFolderURL));

	// RegExp: convert class identifier to module identifier - in future should probably convert to module ids
	const RE_CLASS_TO_MODULE = /\./g;

	// String: prefix for latest server configuration files
	let _configurationPrefix;

	// Number: last time received from the server and corresponding client time - used to generate approximate server time
	let _timeClient = 0;
	let _timeServer = 0;

	/**
	 * Add extension to url if it is not there already.
	 */
	function _addExtension(url, ext) {
		return url ? (url + (url.indexOf(ext) < 0 ? ext : "")) : null;
	}

	// copy of Dojo 'contextRequire' function from dojo-webpack-plugin with
	// 'findModule' replaced with 'window.require' and a result returned from the module callback function
	function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
		var type = ({}.toString).call(a1);
		if (type === '[object String]') {
			// a3 is passed by require calls injected into dependency arrays for dependencies specified
			// as identifiers (vs. string literals).
			var noInstall = !(a3 === false);
			return require(a1, referenceModule, noInstall);
		} else if (type === '[object Object]') {
			throw new Error('Require config is not supported by WebPack');
		}
		if (type === '[object Array]') {
			var modules = [], callback = a2, errors = [];
			a1.forEach(function (mid) {
				try {
					// pass the 3rd parameter as 'false' to force the installation of the module if it's not installed yet
					modules.push(require(mid, referenceModule, false));
				} catch (e) {
					errors.push({ mid: mid, error: e });
				}
			});
			var result;
			if (errors.length === 0) {
				if (callback) {
					result = callback.apply(this, modules);
				}
			} else {
				var error = new Error("findModules");
				error.src = "dojo-webpack-plugin";
				error.info = errors;
				require.signal("error", error);
			}
			return result;
		} else {
			throw new Error('Unsupported require call');
		}
	}

	/**
	 * Wait for DOM to be loaded and then parse - localization resources must be loaded first
	 */
	const windowLoadPromise = new Promise(resolve => {
		window.addEventListener('load', resolve);
	});

	async function loadHtml() {
		return windowLoadPromise.then(() => {
			parser.parse();
		});
	}

	/**
	 * Return name of application
	 */
	function productName() {
		const csiConfig = win.global["csiConfig"];
		return (csiConfig && csiConfig.Product) || "C8";
	}

	/**
	 * Copy of 'registerAbsMids' from dojo-webpack-plugin
	 */
	function registerAbsMids(absMids) {
		for (var s in absMids) {
			require.absMids[s] = absMids[s];
			require.absMidsById[absMids[s]] = s;
		}
	}

	/**
	 * Register the module with Webpack system
	 * @param {string} moduleId - example is Site
	 * @param {string} modulePath - example is Generated/2018-09-09-Site
	 * @param {*} moduleResult - the object representing exports of this module
	 */
	function registerWebpackModule(moduleId, modulePath, moduleResult) {
		modulePath = modulePath || moduleId;

		// register absMids
		var absMids = {};
		absMids[moduleId] = modulePath;
		registerAbsMids(absMids);

		// now add the module to the map of modules

		// __webpack_require__ is available as a parameter in the closure for every module processed by Webpack;
		// __webpack_require__.m is a list of modules. Key is the module path, the value is the function
		__webpack_require__.m[modulePath] = function (module, exports, __webpack_require__) {
			module.exports = moduleResult;
		};
	}

	/**
	 * Resolve given function. If first parameter is string, then resolve function as member against given scope; otherwise, attach to given scope
	 * @param {any} func
	 * @param {Object} [defaultScope]
	 * @return {Function}
	 */
	function resolveFunction(func, defaultScope) {
		if (typeof func === "string") {
			try {
				// determine if function name includes module scope, such as "SiteAdmin.foo"
				var s = func;
				var n = s.lastIndexOf(".");
				if (n > 0) {
					var mid = s.substring(0, n);

					defaultScope = syncRequire(mid);

					s = s.substring(n + 1);
				}

				// if no module given, then try resolving against default scope
				if (defaultScope[s]) {
					return lang.hitch(defaultScope, s);
				}

				console.error("Missing function: ", func);
			} catch (ex) {
				console.error("Missing function: ", func, ex);
			}

			return null;
		}

		return func;
	}

	/**
	 * Load a javascript module in the bundle
	 * @param {any} module
	 * @return {any}
	 */
	function syncRequire(module) {
		if (!module) {
			return null;
		}

		if (typeof module !== "string") {
			return module;
		}

		try {
			// dojo-webpack-plugin specific require to initialize module
			return require(module.replace(RE_CLASS_TO_MODULE, "/"), null, false);
		} catch (ex) {
			console.error("Missing module: ", module, ex, ex.stack ? ex.stack : null);
			return null;
		}
	}

	var csi = {
		// String constants
		DIALOG_URL: "centric://GO_TO_DIALOG",
		EMPTY_STRING: "",
		EMPTY_URL: "centric:",
		EMPTY_FILE_URL: "cf:",
		EMPTY_CHAR: "&nbsp;",
		CONFIGURATION_PREFIX_SET_TOPIC: "/csi/configuration/prefix_set",
		MENU_ITEM_SEPARATOR: "csi-menu-item-separator",
		SERVER_WEB_APP_URL: ServerWebAppURL,
		SERVER_URL: serverUrl,

		browserWindow: function (/*String*/loc, /*String?*/name, /*Object?*/specs) {
			var w = window.open(loc, name || "_blank");
			if (w) w.focus();
			return w;
		},

		getCurrentLocale: function () {
			// summary: return locale from browser according to C8 rules (replace "-" with "_" and "en-us" with "en")
			var loc = config.locale;
			if (loc) {
				loc = loc.replace(/en\-us/, "en").replace(/\-/, "_");

				// ensure that locales with "_" match our internal locale names, so make second part uppercase
				var a = loc.split("_");
				if (a[1]) {
					loc = a[0] + "_" + a[1].toUpperCase();
				}
			}

			return loc;
		},

		getCurrentTime: function () {
			// summary: return approximate server time using last known server time and difference between now and when server time was stored
			return _timeServer + Math.round(new Date().getTime() - _timeClient);
		},

		setCurrentTime: function (/*Number*/value) {
			// summary: store latest server time
			_timeClient = new Date().getTime();
			_timeServer = value;
		},

		error: function (/*Deferred*/dfd, /*Error*/err, /*Boolean*/bConnectionError) {
			// summary: common error handler
			if (bConnectionError || !_configurationPrefix) {
				// if specifically a connection error, then notify app to do what it pleases;
				// DE22852: treat any error that occurs before configuration loaded as a connection error too
				topic.publish("/csi/xhr/drop", err);
			}

			if (dfd) {
				// if deferred, then reject
				dfd.reject(err);
			} else if (config.isDebug) {
				// output error to console if in debug mode
				console.error("Unhandled error: ", err);
			} else {
				// issue error message and reload page
				alert(err.message);
				location.reload();
			}
		},

		fromJson: function (/*String*/json) {
			// summary: parse given JSON string, and if it fails, catch error and return null.
			if (json) {
				try {
					return JSON.parse(json);
				} catch (ex) {
					console.error("fromJson: cannot parse given JSON: " + json);
				}
			}

			return null;
		},

		image: function (/*String*/file) {
			// summary: return url to image in WebAccess/Images folder
			return file ? this.url(ImageFolder + file) : null;
		},

		requestUrl: function (/*String?*/url, /*Boolean?*/bWithServerDomain) {
			// summary: url should be relative to /csi-requesthandler/plm
			return (bWithServerDomain ? serverUrl : "") + RootRequestURL + (url || "");
		},

		url: function (/*String?*/path, /*Boolean?*/bWithServerDomain) {
			// summary: path should be relative to /WebAccess/, such as Images/A.png or Html/2Views.html
			return (bWithServerDomain ? serverUrl : "") + RootFolderURL + (path || "");
		},

		/**
		 * Return name of generated file relative to WebAccess folder
		 * @param {string} file
		 * @param {boolean} [bPrefix]
		 * @return {string}
		 */
		generatedFile(file, bPrefix) {
			return GeneratedFolder + (bPrefix ? _configurationPrefix : "") + file;
		},

		/**
		 * Return name of site file relative to WebAccess folder
		 * @param {string} file
		 * @return {string}
		 */
		siteFile(file) {
			return SiteFolder + file;
		},

		urlForGenerated: function (/*String*/file, /*Boolean*/bPrefix) {
			// summary: return url to generated file, optionally including prefix
			if (bPrefix && !_configurationPrefix) {
				return null;
			}

			return this.url(this.generatedFile(file, bPrefix));
		},

		urlForSite: function (/*String*/file) {
			return this.url(this.siteFile(file));
		},

		urlForModule: function (/*String*/path) {
			// summary: return url to module given path relative to WebAccess folder or starting with known module
			var modUrl = require.toUrl(path);
			return this.url(modUrl);
		},

		getUniqueId: function () {
			// summary: return unique id with timestamp - if you just need an integer, use _.uniqueId()
			return _.uniqueId(String(new Date().getTime()));
		},

		loadConfigurationPrefix: function () {
			// summary: load prefix for other configuration files
			return xhr(this.urlForGenerated("ConfigurationPrefix.js"), {
				handleAs: "javascript",
				preventCache: true
			}).then(function (res) {
				csi.setConfigurationPrefix(res);
			}, function (err) {
				csi.setConfigurationPrefix(null);
			});
		},

		setConfigurationPrefix: function (prefix) {
			_configurationPrefix = prefix;
			console.log("Configuration prefix = " + prefix);
			topic.publish(csi.CONFIGURATION_PREFIX_SET_TOPIC, prefix);
		},

		loadCss: function (/*String*/url) {
			try {
				var eHead = document.getElementsByTagName("head")[0];
				var cssNode = document.createElement("link");
				cssNode.type = "text/css";
				cssNode.rel = "stylesheet";
				cssNode.href = _addExtension(url, ".css");
				eHead.appendChild(cssNode);
			} catch (ex) {
				console.warn(ex.message);
			}

		},

		loadScript: function (/*String*/url, /*String*/handleAs, /*Boolean*/preventCache, /*Boolean*/ ignoreExtension) {
			// summary: load Javascript file with path relative to WebAccess folder
			let urlToLoad = ignoreExtension ? url : _addExtension(url, ".js");
			return xhr(urlToLoad, {
				handleAs: (handleAs || "javascript"),
				sync: false,
				preventCache
			}).then(null, function (err) {
				console.error("Error loading file=", url, "Error=", err);
				throw err;
			});
		},

		loadDojoModule: function (moduleId, modulePath, preventCache) {
			// summary: load Dojo dynamically.
			// Note: it doesn't load dependencies dynamically.
			// The function presumes that all dependencies loaded already.

			modulePath = modulePath || moduleId;

			function onSuccess(response) {
				// call the loaded source as a function with 'contextRequire' as a parameter for 'define' and 'require'
				var source = "return " + (response || "") + "\n//# sourceURL=" + moduleId;
				var result = Function("define", "require", source)(contextRequire, contextRequire);
				console.log("Dojo module '" + moduleId + "' is loaded from the file '" + modulePath + "'");

				registerWebpackModule(moduleId, modulePath, result);

				return result;
			}

			return csi.loadScript(require.toUrl(modulePath), "text", preventCache).then(onSuccess);
		},

		evalScript: function (/*Script*/script) {
			return Function("return " + script)();
		},

		loadXml: function (/*String*/url) {
			return xhr(_addExtension(url, ".xml"), {
				handleAs: "xml",
				sync: false
			}, true).then(function (response) {
				// response should be XML document - if not valid XML, then it appears to be string
				if (_.isString(response)) {
					throw new Error("Invalid XML file=", url);
				}

				return response;
			}, function (err) {
				console.error("Error loading file=", url, "Error=", err);
				throw err;
			});
		},

		markAsProgress: function (/*Boolean*/b) {
			// Add the special element to the body to help the client unit tests understand that the loading is started/completed.
			// use 'class' attribute to indicate the state
			var e = dom.byId("csi_page_complete") || domConstruct.create("span", {
				id: "csi_page_complete"
			}, win.body());

			e.setAttribute("class", b ? "false" : "true");
		},

		contextRequire,
		loadHtml,
		productName,
		registerWebpackModule,
		resolveFunction,
		syncRequire
	};

	lang.mixin(csi, csiArray);
	lang.mixin(csi, csiObject);

	// set operating system specific class on body tag
	var body = win.body();
	var OS = "csi-os-" + window.navigator.platform.slice(0, 3); // get operating system name
	domClass.add(body, OS);

	return csi;
});